import React, { useState } from 'react';
import { updatePassword } from '../../services/emailApi';
import BrandLogo from '../BrandLogo';

const ResetPassword = ({ recoveryToken, onComplete }) => {
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!recoveryToken) {
      setError('This password reset link is invalid or expired.');
      return;
    }
    if (password.length < 8 || password.length > 128) {
      setError('Password must be between 8 and 128 characters.');
      return;
    }
    if (password !== confirmation) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    const result = await updatePassword(recoveryToken, password);
    setLoading(false);
    if (!result.success) {
      setError(result.message || 'Password could not be updated.');
      return;
    }
    setSuccess(true);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-blue-100">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md">
        <BrandLogo className="mb-6" />
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Choose a new password</h1>
        {success ? (
          <>
            <p className="text-gray-600 mb-6">
              Your password has been updated. Sign in with the new password.
            </p>
            <button onClick={onComplete} className="w-full btn-primary">
              Back to login
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <p className="text-gray-600">Use at least eight characters.</p>
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}
            <label className="block">
              <span className="block text-sm font-medium text-gray-700 mb-2">New password</span>
              <input
                type="password"
                autoComplete="new-password"
                required
                minLength={8}
                maxLength={128}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
              />
            </label>
            <label className="block">
              <span className="block text-sm font-medium text-gray-700 mb-2">Confirm password</span>
              <input
                type="password"
                autoComplete="new-password"
                required
                minLength={8}
                maxLength={128}
                value={confirmation}
                onChange={(event) => setConfirmation(event.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
              />
            </label>
            <button
              type="submit"
              disabled={loading || !recoveryToken}
              className="w-full btn-primary disabled:opacity-50"
            >
              {loading ? 'Updating…' : 'Update password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
